exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loading[data-v-818347d4] {\n  width: 100%;\n  text-align: center;\n}\n.loading .desc[data-v-818347d4] {\n  line-height: 20px;\n  font-size: 12px;\n  color: #fff;\n}\n", "", {"version":3,"sources":["E:/h5/z-project-other/xinhuayun-h5/src/components/loading.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,mBAAmB;CACpB;AACD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;CACb","file":"loading.vue","sourcesContent":["\n.loading[data-v-818347d4] {\n  width: 100%;\n  text-align: center;\n}\n.loading .desc[data-v-818347d4] {\n  line-height: 20px;\n  font-size: 12px;\n  color: #fff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-818347d4","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/after-less-loader.js!./node_modules/less-loader?{'modifyVars':{'theme-color':'#509efd','opacity-disabled':'0.5','bg':'#25262a'},'sourceMap':true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/loading.vue
// module id = EYAr
// module chunks = 0